<template>
  <div class="tenant-sidebar-tree" :data-depth="depth">
    <div
      v-for="node in normalizedNodes"
      :key="node.key"
      class="tenant-sidebar-node"
      :style="depthStyle"
    >
      <el-submenu
        v-if="node.children.length"
        :index="node.index"
        popper-append-to-body
      >
        <template slot="title">
          <tenant-sidebar-item-content
            :icon="node.icon"
            :title="node.title"
            :reserve-icon-space="reserveIconSpace"
          />
        </template>
        <tenant-sidebar-tree
          :nodes="node.children"
          :depth="depth + 1"
          @select="selectNode"
        />
      </el-submenu>
      <el-menu-item
        v-else
        :index="node.index"
        @click="selectNode(node)"
      >
        <tenant-sidebar-item-content
          :icon="node.icon"
          :title="node.title"
          :reserve-icon-space="reserveIconSpace"
        />
      </el-menu-item>
    </div>
  </div>
</template>

<script>
import TenantSidebarItemContent from '@/components/TenantSidebarItemContent/index.vue'

export default {
  name: 'TenantSidebarTree',
  components: {
    TenantSidebarItemContent
  },
  props: {
    nodes: {
      type: Array,
      default: () => []
    },
    depth: {
      type: Number,
      default: 0
    }
  },
  computed: {
    normalizedNodes() {
      return (Array.isArray(this.nodes) ? this.nodes : [])
        .filter(node => node && node.index !== null && node.index !== undefined)
        .map((node, position) => ({
          ...node,
          key: String(node.key || node.index || position),
          index: String(node.index),
          title: node.title === null || node.title === undefined
            ? ''
            : String(node.title),
          icon: node.icon ? String(node.icon) : '',
          children: Array.isArray(node.children) ? node.children : []
        }))
    },
    reserveIconSpace() {
      return this.normalizedNodes.some(node => node.icon)
    },
    itemIndent() {
      const depth = Math.max(0, this.depth)
      const depthIndent = 20 + depth * 20
      return depth > 0 && !this.reserveIconSpace
        ? Math.max(depthIndent, 48)
        : depthIndent
    },
    depthStyle() {
      return {
        '--tenant-sidebar-indent': `${this.itemIndent}px`
      }
    }
  },
  methods: {
    selectNode(node) {
      if (node) {
        this.$emit('select', node)
      }
    }
  }
}
</script>
